import React from "react";
import { colorWithOpacity } from "./CalendarConstants";
import { getEventColor } from "./CalendarUtils";

const AllDayEventsBar = ({ events, onTap }) => {
  if (!events || !events.length) return null;

  return (
    <div style={{
      width: "100%",
      padding: "6px 12px",
      backgroundColor: "#FAFAFA",
      borderBottom: "1px solid #E0E0E0",
      display: "flex",
      flexWrap: "wrap",
      gap: 6,
      rowGap: 4,
    }}>
      {events.map((event, i) => {
        const color = getEventColor(event);
        return (
          <div
            key={event.id || i}
            onClick={() => onTap(event)}
            style={{
              padding: "4px 8px",
              backgroundColor: colorWithOpacity(color, 0.15),
              borderLeft: `3px solid ${color}`,
              borderRadius: 4,
              cursor: "pointer",
              maxWidth: 200,
            }}
          >
            <div style={{
              fontSize: 12,
              fontWeight: 500,
              color,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}>
              {event.title}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default React.memo(AllDayEventsBar);
